"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fallback = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Fallback.css");
var _useFallbackShape2 = require("@cbhq/cds-common/hooks/useFallbackShape");
var _Box = require("./Box");
const _excluded = ["height", "shape", "width", "percentage", "disableRandomRectWidth", "rectWidthVariant"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const fallback = "cds-fallback-f1lr71nc";
const Fallback = /*#__PURE__*/(0, _react.memo)(function Fallback(_ref) {
  let height = _ref.height,
    _ref$shape = _ref.shape,
    shape = _ref$shape === void 0 ? 'rectangle' : _ref$shape,
    baseWidth = _ref.width,
    percentage = _ref.percentage,
    disableRandomRectWidth = _ref.disableRandomRectWidth,
    rectWidthVariant = _ref.rectWidthVariant,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const fallbackShapeOptions = (0, _react.useMemo)(() => ({
    disableRandomRectWidth,
    rectWidthVariant
  }), [disableRandomRectWidth, rectWidthVariant]);
  const _useFallbackShape = (0, _useFallbackShape2.useFallbackShape)(shape, baseWidth, fallbackShapeOptions),
    width = _useFallbackShape.width,
    borderRadius = _useFallbackShape.borderRadius;
  const backgroundSizeHeight = typeof height === 'number' ? `${height}px` : height;
  const style = (0, _react.useMemo)(() => ({
    width: percentage ? `100%` : width,
    backgroundSize: `600px ${backgroundSizeHeight}`,
    height,
    borderRadius
  }), [percentage, width, backgroundSizeHeight, height, borderRadius]);
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    flexGrow: 0,
    flexShrink: 0,
    width: percentage && typeof width === 'number' ? `${Math.min(width, 100)}%` : width
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: fallback,
    style: style
  }, "\xA0"));
});
exports.Fallback = Fallback;